import {Component, OnInit} from '@angular/core';
import {PaymentService} from "../../services/payment-service";
import {HeaderService} from "../../../tandem-core/services/header.service";
import {DialogService} from "../../../tandem-core/services/dialog.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../auth/services/auth.service";
import {take} from "rxjs/operators";
import {TandemUser} from "../../../auth/models/tandem-user";
import {StripeOperationsService} from "../../services/stripe-operations.service";

@Component({
  selector: 'tandem-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {

  user: TandemUser | null = null;
  sessionId: string | null = null;
  errorMessage?: string;
  isLoaded = false;

  constructor(private auth: AuthService,
              private stripeOperationsService: StripeOperationsService,
              private dialogService: DialogService,
              private headerService: HeaderService,
              private route: ActivatedRoute,
              private router: Router) {
    this.sessionId = this.route.snapshot.queryParamMap.get('session_id');
  }
  ngOnInit(): void {
    this.auth.$user.pipe(take(1)).subscribe(user => {
      this.user = user;
      this.headerService.setConfig({hideHeader: true});
      if (this.sessionId) {

        this.dialogService.openModal2({
          title: 'Finalizing Account',
          type: 'loading',
          content: `Good news, we've processed your payment ${this.user?.coachType === 'coachLeadGen' ? 'information' : ''}! One moment while we finalize your account.`
        });

        if (this.user?.coachType === 'coachLeadGen') {
          this.stripeOperationsService.validateStripeForLGCoach(this.sessionId).subscribe(res => {
            this.dialogService.openModal2({
              title: 'Success',
              content: 'Successfully finalized your Stripe account! You now have full access to the Tandem Platform, and you\'re ready to start inviting users!',
              type: 'success',
              actions: [
                {
                  text: 'Go to Dashboard',
                  role: 'close',
                  callback: () => {
                    this.auth.forceTokenRefresh().then(res => {
                      this.dialogService.closeModal2();
                      this.router.navigate(['/dashboard']);
                    })
                  }
                }
              ]
            });
            // Check if the user's email is verified
            // this.auth.userPermsSubject.next(); // Trigger userPerms update
          }, error => {
            this.dialogService.openModal2({
              title: 'Unexpected Error',
              content: 'Your payment information was successfully saved in Stripe, but something went wrong on our end. Please try again, or reach out to Tandem support.',
              type: 'failure',
              actions: [
                {
                  text: 'Close',
                  role: 'close',
                  callback: () => {
                    this.dialogService.closeModal2();
                    this.router.navigate(['/dashboard']);
                  }
                }
              ]
            });
          })
        } else if (this.user?.accountType === 'user') {
          this.stripeOperationsService.validateStripeForUserOfRSCoach(this.sessionId, this.user.coachId || '').subscribe(res => {
            this.dialogService.openModal2({
              title: 'Success',
              content: 'Successfully finalized your account, you now have full access!',
              type: 'success',
              actions: [
                {
                  text: 'Go to Dashboard',
                  role: 'close',
                  callback: () => {
                    this.auth.forceTokenRefresh().then(res => {
                      this.dialogService.closeModal2();
                      this.router.navigate(['/dashboard']);
                    })
                  }
                }
              ]
            });
          }, error => {
            this.dialogService.openModal2({
              title: 'Unexpected Error',
              content: 'Your payment was processed through Stripe, but it looks like there was an issue in processing your payment on our end. Please contact your coach or support.',
              type: 'failure',
              actions: [
                {
                  text: 'Close',
                  role: 'close',
                  callback: () => {
                    this.dialogService.closeModal2();
                    this.router.navigate(['/dashboard']);
                  }
                }
              ]
            });
          });
        }
      }
    });

  }

}
